import {useParams} from 'react-router-dom';
import {useTenantContext} from '@/app/TenantContext';
import {ServiceRow} from '@/components/booking/ServiceRow';
import {AsyncBoundary} from '@/components/AsyncBoundary';
import {TenantFooter} from '@/components/layout/TenantFooter';
import {TenantHeader} from '@/components/layout/TenantHeader';

export function TenantServicesPage() {
  const {tenant, services} = useTenantContext();
  const {slug = ''} = useParams();

  return (
    <div className="flex min-h-[calc(100dvh-6rem)] flex-1 flex-col">
      <TenantHeader />
      <div className="stagger flex flex-col gap-6 px-4 pb-8 pt-6">
        <div className="flex flex-col gap-3">
          <h1 className="m-0 text-[34px] font-bold leading-[1.05] tracking-tight text-foreground">Услуги и цены</h1>
          <p className="m-0 text-[16px] leading-relaxed text-muted-foreground">
            Цены и длительность указаны студией. Выберите услугу, чтобы увидеть свободное время.
          </p>
        </div>
        <AsyncBoundary isEmpty={services.length === 0} emptyTitle="Услуги пока не добавлены">
          <div className="panel flex flex-col gap-1 rounded-[28px] p-2">
            {services.map((service) => (
              <ServiceRow key={service.id} slug={slug} service={service} locale={tenant.locale} variant="full" />
            ))}
          </div>
        </AsyncBoundary>
      </div>
      <TenantFooter />
    </div>
  );
}
